import axios from "axios";

const BASE = `${process.env.REACT_APP_BACKEND_URL}/api`;

export const client = axios.create({ baseURL: BASE });

client.interceptors.request.use((config) => {
  const token = localStorage.getItem("token");
  if (token) config.headers.Authorization = `Bearer ${token}`;
  return config;
});

function normalizeError(err) {
  const payload = err?.response?.data?.error;
  return {
    code: payload?.code || "error",
    message: payload?.message || "Something went wrong. Please try again.",
    status: err?.response?.status,
  };
}

async function request(promise) {
  try {
    const res = await promise;
    return res.data; // { data, meta }
  } catch (err) {
    throw normalizeError(err);
  }
}

export const api = {
  get: (url, params) => request(client.get(url, { params })),
  post: (url, body, config) => request(client.post(url, body, config)),
  patch: (url, body) => request(client.patch(url, body)),
  del: (url) => request(client.delete(url)),
  raw: client,
  base: BASE,
};
